import React, { Fragment, useEffect, useState } from "react";
import { Col, Form, Modal, Select, Icon } from "antd";
import ConfirmButton from "../../../components/buttons/ConfirmButton";
import CancelButton from "../../../components/buttons/CancelButton";

import { georegionsApiUpsellProvider } from "../../../lib/api/providers";

import { EditAttribute, TypologyEdition, RetailerEdition } from "../Components/CustomInput.component";
import { retailers } from "../Constants/temp.constants";

export const CreationPdcKeys = {
  pdc_label: "Nom du pdc",
  address: "Adresse",
  zip_code: "Code postal",
  city: "Ville",
  typology_id: "Typologie",
  retailer_id: "Enseigne",
  phone: "Téléphone",
  fax: "Fax",
  gps_lat: "Latitude",
  gps_long: "Longitude",
  surface: "Superficie"
};
const EditPdc = ({ pdc = {}, onSubmit, token, isRequest = true }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [updatedData, setUpdatedData] = useState(pdc);
  const [cities, setCities] = useState([]);
  const [zipCode, setZipCode] = useState(pdc.zip_code || "");

  const fetchCities = async () => {
    const result = await georegionsApiUpsellProvider.post(
      "/distincts/city_label",
      { match: { zip_code: zipCode } },
      {
        headers: {
          Authorization: token
        }
      }
    );
    setCities(result.data);
  };
  useEffect(() => {
    if (zipCode.length === 5) fetchCities();
  }, [zipCode]);

  return (
    <Fragment>
      <Modal
        visible={isModalVisible}
        title={isRequest ? "Editer la requête" : "Editer le pdc"}
        onCancel={() => setIsModalVisible(false)}
        footer={[
          <ConfirmButton
            label="Valider"
            large={true}
            _code
            onClick={() => {
              onSubmit(updatedData);
              setIsModalVisible(false);
            }}
          />,

          <CancelButton
            label="Annuler"
            large={true}
            onClick={() => setIsModalVisible(false)}
            classes={"p-mrg-left-s"}
          />
        ]}
      >
        {Object.entries(CreationPdcKeys)
          .filter(([key, _]) => key !== "typology_id" && key !== "retailer_id" && key !== "city")
          .map(([key, label]) => (
            <Fragment key={key}>
              <EditAttribute
                label={label}
                _key={key}
                value={updatedData[key]}
                handleChange={newValue => {
                  const newData = { ...updatedData, [key]: newValue };
                  if (key === "zip_code" && newValue.length === 5) setZipCode(newValue);
                  setUpdatedData(newData);
                }}
              />
            </Fragment>
          ))}
        <div style={{ width: "100%" }}>
          <div style={{ margin: 5, display: "flex", alignItems: "center" }}>
            <Col span={5}>
              <span style={{ fontWeight: "bold", marginRight: 5 }}>Ville </span>
            </Col>
            <Col span={16}>
              <Select
                defaultValue={updatedData.city}
                placeholder={
                  cities.length > 0 ? "Selectionner une ville" : "Définir le code postal avant de sélectionner la ville"
                }
                onChange={city => {
                  const newData = { ...updatedData, city };
                  setUpdatedData(newData);
                }}
                style={{ width: "100%" }}
                maxTagCount={20}
                showArrow={cities.length > 0}
                disabled={cities.length === 0}
              >
                {cities.map(city => {
                  return (
                    <Select.Option key={city} value={city}>
                      {city}
                    </Select.Option>
                  );
                })}
              </Select>
            </Col>
          </div>
        </div>
        <div style={{ width: "100%" }}>
          <RetailerEdition
            retailer_id={updatedData.retailer_id}
            handleChange={newValue => {
              const newRetailer = retailers.find(retailer => retailer.id === newValue) || {};
              const newData = { ...updatedData, retailer_id: newValue, retailer_label: newRetailer.label };
              setUpdatedData(newData);
            }}
          ></RetailerEdition>
        </div>
        <div style={{ width: "100%" }}>
          <TypologyEdition
            _key={"typology"}
            value={updatedData.typology}
            handleChange={newValue => {
              const newData = { ...updatedData, typology_id: newValue };
              setUpdatedData(newData);
            }}
          ></TypologyEdition>
        </div>
      </Modal>
      <div className="p-btn p-btn-grey" onClick={() => setIsModalVisible(true)}>
        {isRequest ? "Editer la requête" : <Icon type="edit" />}
      </div>
    </Fragment>
  );
};

export default Form.create()(EditPdc);



// WEBPACK FOOTER //
// src/pages/basepdc/detailPdc/Edit.detailpdc.js